import { logToNewRelic } from '../../services/debug';

let active = 0;
let totalMounted = 0;

export const riveLoadInstrumentation = {
  incActive(): { active: number; mountIndex: number } {
    active += 1;
    totalMounted += 1;
    return { active, mountIndex: totalMounted };
  },
  decActive(): void {
    active = Math.max(0, active - 1);
  },
  getActive(): number {
    return active;
  },
};

export type RiveLoadOutcome = 'success' | 'timeout' | 'error' | 'abandoned';

export type RiveLoadPayload = {
  src?: string;
  durationMs: number;
  activeRiveCount: number;
  mountIndex: number;
  cacheHit: boolean;
  isPreload: boolean;
  outcome: RiveLoadOutcome;
  errorMessage?: string;
  timeoutMs?: number;
};

function getEnvSignal() {
  const nav: any = typeof navigator !== 'undefined' ? navigator : {};
  const conn = nav.connection || nav.mozConnection || nav.webkitConnection || null;
  return {
    deviceMemory: nav.deviceMemory ?? null,
    hardwareConcurrency: nav.hardwareConcurrency ?? null,
    effectiveType: conn?.effectiveType ?? null,
    saveData: conn?.saveData ?? null,
    rtt: conn?.rtt ?? null,
    downlink: conn?.downlink ?? null,
  };
}

export function logRiveLoad(payload: RiveLoadPayload): void {
  const { outcome, durationMs, src, errorMessage } = payload;
  const method = outcome === 'error' ? 'error' : outcome === 'timeout' ? 'warn' : 'info';
  const message = `rive ${outcome} ${src ?? '?'} ${durationMs}ms${errorMessage ? ` - ${errorMessage}` : ''}`;

  logToNewRelic('Rive Load Telemetry', { message, ...payload, ...getEnvSignal() }, method);
}
